import Actions                  from 'Redux/Actions';
import { AppUserRepository }      from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { message }              from 'antd';

export const updateAppUserEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.updateAppUserRequest.type),
    mergeMap(action => from(AppUserRepository.update(action.payload.id, action.payload.formData))
      .pipe(
        mergeMap((appUser) => {
          message.success('Die Speicherung des Nutzers erfolgreich.');

          return from([
            Actions.updateAppUserSuccess({ appUser }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.updateAppUserFailure({ error })
          ]);
        })
      )
    ),
  );
};
